import React from 'react';
import { useTranslation } from 'react-i18next';
import { LifeBuoy, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { useAuth } from '@/contexts/AuthContext';
import LanguageSelector from '@/components/LanguageSelector';
import InstallAppButton from '@/components/InstallAppButton';
import { openSupport } from '@/components/SupportButton';

// Header actions hidden on phones live here (inside the Settings dialog).
export const MobileQuickActions = ({ onClose }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  return (
    <div className="sm:hidden space-y-3" data-testid="mobile-quick-actions">
      <div>
        <Label className="text-xs text-slate-500">{t('common.language')}</Label>
        <div className="mt-1"><LanguageSelector /></div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <InstallAppButton className="h-10 w-full text-sm" />
        <Button variant="outline" className="h-10 text-sm" data-testid="mobile-support-button" onClick={() => { onClose?.(); openSupport(); }}>
          <LifeBuoy size={16} className="mr-1.5" /> {t('common.support')}
        </Button>
      </div>
      <Button variant="ghost" className="w-full h-10 text-sm text-red-600 hover:bg-red-50 hover:text-red-700" data-testid="mobile-logout-button" onClick={logout}>
        <LogOut size={16} className="mr-1.5" /> {t('common.logout')}
      </Button>
      <div className="border-t border-slate-200"></div>
    </div>
  );
};

export default MobileQuickActions;
